// src/components/Disclaimer.js
import React from 'react';

function Disclaimer() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          免責事項
        </h1>
        <p className="text-gray-700">
          本サービスの利用によって生じた損害について、運営者は一切の責任を負いません。
          また、外部サービス（決済サービス・通信サービス等）の障害に起因する損害についても責任を負いかねます。
          利用者は自己の責任と判断において本サービスを利用するものとします。
        </p>
      </div>
    </div>
  );
}

export default Disclaimer;
